import { ADMIN_USERS_LIST } from './index';
import { Action } from '../action';

export class AdminUsersListInitAction implements Action {
	readonly type = ADMIN_USERS_LIST.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminUsersListDestroyAction implements Action {
	readonly type = ADMIN_USERS_LIST.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminUsersListHydrateAction implements Action {
	readonly type = ADMIN_USERS_LIST.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminUsersListHydrateSuccessAction implements Action {
	readonly type = ADMIN_USERS_LIST.HYDRATE_SUCCESS;
	constructor(
		public payload: any[],
		public correlationId?: number
	) {}
}

export class AdminUsersListHydrateFailureAction implements Action {
	readonly type = ADMIN_USERS_LIST.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminUsersListClickEditAction implements Action {
	readonly type = ADMIN_USERS_LIST.CLICK_EDIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminUsersListSelectAction implements Action {
	readonly type = ADMIN_USERS_LIST.SELECT;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminUsersListSelectUserAction implements Action {
	readonly type = ADMIN_USERS_LIST.SELECT_USER;
	constructor(
		public payload: number,
		public correlationId?: number
	) {}
}

export class AdminUsersListDeleteUserAction implements Action {
	readonly type = ADMIN_USERS_LIST.DELETE_USER;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminUsersListDeleteUserSuccessAction implements Action {
	readonly type = ADMIN_USERS_LIST.DELETE_USER_SUCCESS;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminUsersListDeleteUserFailureAction implements Action {
	readonly type = ADMIN_USERS_LIST.DELETE_USER_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
